(function () {
  var DEFERRED_SELECTOR = "[data-menu-src], [data-menu-srcset]";
  var MENU_ITEM_SELECTOR = ".menu__item, .header__dropdown, [data-drawer]";

  function hydrateElement(element) {
    var srcset = element.getAttribute("data-menu-srcset");
    var src = element.getAttribute("data-menu-src");

    if (srcset) {
      element.setAttribute("srcset", srcset);
      element.removeAttribute("data-menu-srcset");
    }
    if (src) {
      element.setAttribute("src", src);
      element.removeAttribute("data-menu-src");
    }
  }

  function hydrate(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var deferred = root.querySelectorAll(DEFERRED_SELECTOR);
    for (var i = 0; i < deferred.length; i++) {
      hydrateElement(deferred[i]);
    }
  }

  function hydrateFrom(target) {
    if (!(target instanceof Element)) return;
    var container = target.closest(MENU_ITEM_SELECTOR);
    hydrate(container || document);
  }

  ["pointerover", "touchstart", "focusin"].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        hydrateFrom(event.target);
      },
      { passive: true, capture: true }
    );
  });

  document.addEventListener("click", function (event) {
    hydrateFrom(event.target);
  }, true);

  function warm() {
    if (window.matchMedia && !window.matchMedia("(pointer: fine)").matches) return;
    hydrate(document);
  }

  window.addEventListener("load", function () {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(warm, { timeout: 5000 });
    } else {
      setTimeout(warm, 3000);
    }
  });
})();
